/**
 * LoopToggle Component
 * Loop enable/disable toggle button with visual feedback
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Repeat } from 'lucide-react';

// Format time as MM:SS.ms
const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  const ms = Math.floor((seconds % 1) * 100);
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
};

export const LoopToggle = ({
  loopEnabled,
  setLoopEnabled,
  loopStart = 0,
  loopEnd = 0,
}) => {
  return (
    <Button
      variant={loopEnabled ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setLoopEnabled(!loopEnabled)}
      className={`relative p-2 ${loopEnabled ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/50' : 'text-zinc-400 hover:text-white'}`}
      data-testid="loop-toggle"
      title={loopEnabled ? `Loop: ${formatTime(loopStart)} - ${formatTime(loopEnd)}` : 'Enable Loop'}
    >
      <Repeat className="w-5 h-5" />
    </Button>
  );
};

export default LoopToggle;
